import type {ColorFillPropertyType} from '@Components/color-fill';
import type {RGBA} from '@Utils/color.util';

export const DELAY_FOR_ON_CHANGE = 200;
export const PREVIEW_CIRCLE_SIZE = 32;

/** How the picker arranges its controls: the side-panel column, or the compact card shown in a popover. */
export enum ColorPickerLayout {
  PANEL = 'panel',
  POPUP = 'popup',
}

export interface ColorStorage {
  id: string;
  color: RGBA;
}

export interface ColorPickerProps {
  id: string;
  className?: string;
  color: ColorStorage[];
  onMyDesign: string[];
  type?: ColorFillPropertyType;
  layout?: ColorPickerLayout;
  addDelayToOnChangeColor?: boolean;
  isGradientEnabled?: boolean;
  hideTypeSelector?: boolean;
  showSmallBrandDropdownHeader?: boolean;
  isAlphaDisabled?: boolean;
  /** When true, the solid colour swatch shows the "mixed colours" thumbnail (a multi-selection whose colours differ). */
  isColorMixed?: boolean;
  /** When true the items disagree on fill type: the type dropdown shows `--` and the panel collapses to a single colour row. */
  isTypeMixed?: boolean;

  onChangeColor(color: ColorStorage[]): void;

  onChangeEnded(color?: ColorStorage[]): void;

  onImmediateChange?(): void;

  onChangeType?(type: ColorFillPropertyType): void;

  onChangeColorPickerMode?(state: boolean): void;

  onAddBrandAssetClicked?(): void;

  showOnMyDesignsSection?: boolean;
  showPicker?: boolean;
  onColorSelectedFromBrands?(): void;
}
